<template>
  <el-dialog
    :title="$t('message.bindingAuxiliaryMaterials')"
    :visible.sync="visible"
    width="920px"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="bind-search">
      <el-input v-model.trim="searchName" :placeholder="$t('message.pleaseEnterMaterialName')" clearable />
      <el-button type="primary" :loading="loading" @click="search">{{ $t('message.search') }}</el-button>
    </div>
    <div class="bind-card-list" v-loading="loading">
      <div
        class="bind-card"
        v-for="item in list"
        :key="item.id"
        :class="{ selected: selectedIds.indexOf(item.id) !== -1 }"
        @click="toggle(item)"
      >
        <el-checkbox :value="selectedIds.indexOf(item.id) !== -1" @click.native.stop @change="toggle(item)">
          ID：{{ item.id }}
        </el-checkbox>
        <div class="bind-card-body">
          <el-image v-if="item.main_image" :src="item.main_image" fit="cover" class="bind-img" />
          <div>
            <div class="bind-name" @click.stop="openMaterialDetail(item)">{{ item.name_trans }}</div>
            <p>{{ $t('message.type') }}：{{ item.type_name || (item.type && item.type.name) }}</p>
            <p>{{ $t('message.inventoryQuantity') }}：{{ item.material_stock_num }}</p>
            <div class="consume-row">
              <span>{{ $t('message.materialConsumption') }}：</span>
              <el-input v-model="item.consume" size="mini" class="consume-input" @click.native.stop />
              <span>{{ $t('message.pointPerSet') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="empty-block" v-if="!list.length && !loading">{{ $t('message.noMaterial') }}</div>
    </div>
    <div slot="footer">
      <el-button @click="visible = false">{{ $t('message.cancel') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('message.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
/**
 * 绑定辅料弹框
 * 按客户查询可绑辅料主档，多选后回传 material_id + consume（及展示用字段）
 */
export default {
  name: 'BindMaterialDialog',
  data() {
    return {
      visible: false, // 弹框显隐
      loading: false, // 搜索 loading
      userId: '', // 客户 id，查询辅料列表用
      searchName: '', // 辅料名称搜索关键词
      list: [], // 可绑辅料列表
      selectedIds: [] // 当前勾选的辅料 id 集合
    }
  },
  methods: {
    /**
     * 打开弹框并重置勾选，随即拉取辅料列表
     * @param {String|Number} userId 客户 id
     */
    open(userId) {
      this.userId = userId
      this.searchName = ''
      this.selectedIds = []
      this.visible = true
      this.search()
    },
    // 查询辅料主档列表（warehouseApi.materialList）
    search() {
      this.loading = true
      this.$api.warehouseApi.materialList({
        user_id: this.userId,
        name: this.searchName,
        page: 1,
        pageSize: 999
      }).then(res => {
        const data = res.data || {}
        // 兼容 list / data 两种分页结构；默认消耗为 1
        this.list = (data.list || data.data || []).map(item => ({
          ...item,
          consume: item.consume || 1,
          type_name: item.type_name || (item.type && item.type.name)
        }))
      }).finally(() => {
        this.loading = false
      })
    },
    // 勾选 / 取消勾选辅料卡片
    toggle(item) {
      const index = this.selectedIds.indexOf(item.id)
      if (index === -1) {
        this.selectedIds.push(item.id)
      } else {
        this.selectedIds.splice(index, 1)
      }
    },
    /**
     * 确认绑定：组装提交/展示所需字段后回传
     * material_id、consume 为接口必填；其余字段仅前端展示
     */
    confirm() {
      const selected = this.list
        .filter(item => this.selectedIds.indexOf(item.id) !== -1)
        .map(item => ({
          material_id: item.id,
          consume: item.consume || 1,
          name_trans: item.name_trans,
          main_image: item.main_image,
          material_stock_num: item.material_stock_num,
          type_name: item.type_name || (item.type && item.type.name)
        }))
      this.$emit('confirm', selected)
      this.visible = false
    },
    // 点击辅料名称新开辅料详情
    openMaterialDetail(item) {
      const id = item.id || item.material_id
      if (!id) return
      const route = this.$router.resolve({
        path: '/materialDetail',
        query: {
          id,
          user_id: this.userId || item.user_id || ''
        }
      })
      window.open(route.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.bind-search {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;

  .el-input {
    width: 280px;
  }
}

.bind-card-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  max-height: 480px;
  overflow: auto;
}

.bind-card {
  padding: 12px;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  cursor: pointer;

  &.selected {
    border-color: #B4272D;
    background: #FFF8F8;
  }
}

.bind-card-body {
  display: flex;
  margin-top: 10px;
}

.bind-img {
  flex: 0 0 56px;
  width: 56px;
  height: 56px;
  margin-right: 10px;
  border-radius: 3px;
  background: #D8D8D8;
}

.bind-name {
  margin-bottom: 4px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    color: #B4272D;
  }
}

.consume-row {
  display: flex;
  align-items: center;
  margin-top: 6px;
}

.consume-input {
  width: 72px;
  margin: 0 6px;
}

.empty-block {
  padding: 24px 0;
  color: #999999;
  text-align: center;
}
</style>
